import Accordion from 'accordion-js';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const accordionsContainer = Array.from(
    document.querySelectorAll('.accordion-container')
  );
  new Accordion(accordionsContainer, {
    duration: 400,
    showMultiple: true,
  });
});

document.addEventListener('facetwp-loaded', () => {
  if (window.FWP.loaded) {
    const accordionsContainer = Array.from(
      document.querySelectorAll('.facetwp-template.accordion-container')
    );
    new Accordion(accordionsContainer, {
      duration: 400,
      showMultiple: true,
    });
  }
});
